// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog__term_and_conditions{overflow:hidden!important}@media (min-width:600px){.terminos_and_conditions div{width:auto!important;margin-bottom:0!important;margin-top:35pt;margin-left:85pt;margin-right:85pt}}@media (max-width:600px){.terminos_and_conditions div{width:100%!important;margin-bottom:0!important;margin-top:0!important;margin-left:0!important;margin-right:0!important}}", ""]);
// Exports
module.exports = exports;
